import {
  Box,
  Card,
  IconButton,
  Modal,
  Stack,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import PromptModal from "../common/PromptModal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DELETE_USERS_WORKHISTORY, FETCH_PROJECTS_PRODUCTS } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import "./Viewexperience.css";
import Removeduplicates from "../common/Removeduplicate";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BIBlue, BIGrey } from "../../assets/helpers";
import moment from "moment";
import { setSelectedProjectdata, setShowaddexperience } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import { English } from "../../constant/EnglishFallback";

export default function Viewexperience(props) {
  const { loginData, selectedProject, multiLanguageData } = useSelector((state) => state?.main);

  const navigate = useNavigate();
  const { userId } = useParams();

  const [showDeleteAlertModal, setShowDeleteAlertModal] = useState(false);
  const [projectlist, setProjectlist] = useState([]);
  const [showEdit, setShowedit] = useState(false);
  const dispatch = useDispatch();

  const {
    TEXT_PROMPT_DELETE_EXPERIENCE = English?.Profile?.TEXT_PROMPT_DELETE_EXPERIENCE,
    TEXT_PROMPT_DESC = English?.Profile?.TEXT_PROMPT_DESC,
    BUTTON_MODAL_DELETE_YES = English?.Profile?.BUTTON_MODAL_DELETE_YES,
    BUTTON_MODAL_DELETE_NO = English?.Profile?.BUTTON_MODAL_DELETE_NO,
    TEXT_VIEW_EXPERIENCE = English?.Profile?.TEXT_VIEW_EXPERIENCE,
    TEXT_SITE_PROJECT = English?.Profile?.TEXT_SITE_PROJECT,
    TEXT_LABEL_DESCRIPTION = English?.Profile?.TEXT_LABEL_DESCRIPTION,
    TEXT_COMPANY = English?.Profile?.TEXT_COMPANY,
    TEXT_START_DATE = English?.Profile?.TEXT_START_DATE,
    TEXT_END_DATE = English?.Profile?.TEXT_END_DATE,
    TEXT_PRESENT = English?.Profile?.TEXT_PRESENT,
    TEXT_PRODUCTS_IN_PROFILE = English?.Profile?.TEXT_PRODUCTS_IN_PROFILE,
    TEXT_TITLE_ROLE = English?.Profile?.TEXT_TITLE_ROLE,
    TEXT_TRADE = English?.Profile?.TEXT_TRADE
  } = multiLanguageData?.Profile || {};

  useEffect(() => {
    if (userId === loginData?.userInformation?.UserId) {
      setShowedit(true);
    } else {
      setShowedit(false);
    }
    getProductlist();
  }, [props.viewExperience]);

  const getProductlist = async () => {
    try {
      const getObject = {
        SearchList: [{ projectId: props?.projectData?.projectId }],
        userId: loginData?.userInformation?.UserId,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true
      };
      const res = await Postrequestcall(FETCH_PROJECTS_PRODUCTS, getObject, loginData?.accessToken);
      let resData = res?.data?.data ?? []; // Sorting and preparing response data
      let updatedData = await Removeduplicates(resData, "projectId");
      let sortedData = updatedData?.sort((a, b) => a?.projectName?.localeCompare(b?.projectName));
      setProjectlist([]);
    } catch (error) {
    } finally {
    }
  };

  const handleDeleteButtonClick = async () => {
    try {
      let deleteObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: props.projectData?.id ?? 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      let getResponse = await Postrequestcall(
        DELETE_USERS_WORKHISTORY,
        deleteObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        let getObj = { ...selectedProject, type: "delete" };
        dispatch(setSelectedProjectdata(getObj)); // Store the project data
        props.onClose();
      }
    } catch (error) {
      console.log("handleDeleteButtonClick-> Error WHile Deleting User Work History: ", error);
    } finally {
      setShowDeleteAlertModal(false);
    }
  };

  const onDeleteExperience = () => {
    setShowDeleteAlertModal(true);
  };

  const onEditExperience = () => {
    let getObj = { ...props?.projectData, type: "edit", from: "experience" };
    dispatch(setSelectedProjectdata(getObj)); // Store the project data for edit
    dispatch(setShowaddexperience(true)); // Store the experience data
  };

  const getProductDescriptionText = (item) => {
    if (item.productType && item.manufacturerName) {
      return `${item.productType} | ${item.manufacturerName}`;
    } else if (item.productType) {
      return `${item.productType} `;
    } else if (item.manufacturerName) {
      return `${item.manufacturerName} `;
    } else {
      return "Unknown";
    }
  };

  return (
    <>
      <PromptModal
        isOpen={showDeleteAlertModal}
        onClose={() => setShowDeleteAlertModal(false)}
        title={TEXT_PROMPT_DELETE_EXPERIENCE}
        desc={TEXT_PROMPT_DESC}
        redButtonText={BUTTON_MODAL_DELETE_YES}
        blueButtonTextFirst={BUTTON_MODAL_DELETE_NO}
        onRedButtonClick={handleDeleteButtonClick}
      />
      <Modal open={props.viewExperience}>
        <Box className="user-modal-responsive view-experience">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography className="add-title">{TEXT_VIEW_EXPERIENCE}</Typography>
            <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
              {userId === loginData?.userInformation?.UserId && (
                <>
                  <IconButton size="small" onClick={() => onEditExperience()}>
                    <EditIcon style={{ color: BIBlue }} />
                  </IconButton>
                  <IconButton onClick={() => onDeleteExperience()}>
                    <DeleteIcon color="error" />
                  </IconButton>
                </>
              )}
              <IconButton size="small" onClick={props.onClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>
          <Stack spacing={1}>
            <Typography className="ex-type" color={BIGrey}>
              {TEXT_SITE_PROJECT}
            </Typography>
            <Card
              className="pagelist-content project-card"
              style={{ padding: "10px", alignItems: "center" }}
              onClick={() => {
                navigate(`/project/${props?.projectData?.projectId}`);
              }}>
              <Stack display={"flex"} flexDirection={"row"} gap={1}>
                <img
                  className="project-img"
                  src={
                    props.projectData.mainPictureUrl
                      ? props.projectData.mainPictureUrl
                      : PlaceholderImg
                  }
                  onError={(event) => (event.target.src = PlaceholderImg)}></img>
                <Stack>
                  <Typography>{props?.projectData?.projectName}</Typography>
                  <Typography color={BIGrey}>{props?.projectData?.siteName}</Typography>
                  <Typography color={BIGrey}>{props?.projectData?.address}</Typography>
                </Stack>
              </Stack>
            </Card>
            <Grid container className={"pagelist-content"} style={{ padding: "10px" }}>
              {props?.projectData?.companyName !== "" && (
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} marginBottom={"10px"}>
                  <Typography color={BIGrey}>{TEXT_COMPANY}</Typography>
                  <Typography
                    style={{ cursor: "pointer" }}
                    color={BIBlue}
                    fontWeight={600}
                    onClick={() => {
                      navigate(`/company/${props?.projectData?.companyId}`);
                    }}>
                    {props?.projectData?.companyName}
                  </Typography>
                </Grid>
              )}
              {props?.projectData?.roleName !== "" && (
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} marginBottom={"10px"}>
                  <Typography color={BIGrey}>{TEXT_TITLE_ROLE}</Typography>
                  <Typography>{props?.projectData?.roleName}</Typography>
                </Grid>
              )}
              {props?.projectData?.tradeName !== "" && (
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} marginBottom={"10px"}>
                  <Typography color={BIGrey}>{TEXT_TRADE}</Typography>
                  <Typography>{props?.projectData?.tradeName}</Typography>
                </Grid>
              )}
              {props?.projectData?.startDate !== null && (
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} marginBottom={"10px"}>
                  <Typography color={BIGrey}>{TEXT_START_DATE}</Typography>
                  <Typography>
                    {moment(props?.projectData?.startDate).format("MMM YYYY")}
                  </Typography>
                </Grid>
              )}
              {props?.projectData?.endDate !== null && (
                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} marginBottom={"10px"}>
                  <Typography color={BIGrey}>{TEXT_END_DATE}</Typography>
                  <Typography>
                    {props?.projectData?.present
                      ? TEXT_PRESENT
                      : moment(props?.projectData?.endDate).format("MMM YYYY")}
                  </Typography>
                </Grid>
              )}
              {props?.projectData?.description !== "" && (
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} marginBottom={"10px"}>
                  <Typography color={BIGrey}>{TEXT_LABEL_DESCRIPTION}</Typography>
                  <Typography style={{ wordBreak: "break-word" }}>
                    {props?.projectData?.description}
                  </Typography>
                </Grid>
              )}
            </Grid>
            {projectlist?.length > 0 && (
              <Card className="pagelist-content" style={{ padding: "10px" }}>
                <Typography color={BIGrey}>{TEXT_PRODUCTS_IN_PROFILE}</Typography>
                <List disablePadding>
                  {projectlist?.map((item, index) => (
                    <Card
                      key={index} // Using index as a fallback key
                      className="pagelist-content">
                      <ListItem sx={{ m: 0 }} key={index.toString()} disablePadding>
                        <ListItemButton
                          sx={{ display: "flex", flexDirection: "row" }}
                          onClick={() => {
                            navigate(`/product/${item?.productId}`);
                          }}>
                          <ListItemText
                            sx={{ m: 0 }}
                            primary={item?.productName}
                            secondary={getProductDescriptionText(item)}
                          />
                        </ListItemButton>
                      </ListItem>
                    </Card>
                  ))}
                </List>
              </Card>
            )}
          </Stack>
        </Box>
      </Modal>
    </>
  );
}
